
import Vue from 'vue';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import CheckIcon from '~/components/partials/public-portfolio/assets/check-circle.vue.svg';
import PublicPortfolioModal from '~/components/partials/public-portfolio/PublicPortfolioModal.vue';

export default Vue.extend({
  name: 'PublicPortfolioSuccessModal',
  components: { PublicPortfolioModal, CheckIcon, BravadoText },
  props: {
    modalName: {
      type: String,
      required: true,
    },
  },
});
